import React, { useEffect, useState } from 'react'
import HolidayListTable from './HolidayListTable'
import api from '../../../Services/api';
import CustomSnackbar from '../../../Component/CustomSnackBar';
import UploadActsRules from '../Acts_Rules/UploadActsRules';


const UploadHolidayList = () => {
const [snack, setSnack] = useState({ open: false, message: '', severity: 'success' });
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [referenceLink, setReferenceLink] = useState('');
  const [file, setFile] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [error, setErrors] = useState({state:"", year:"", referenceLink: ''})
  const [hasChanged, setHasChanged] = useState(false);
  const [isDragActive, setIsDragActive] = useState(false);




  const triggerSnackbar = (type, message) => {
    setSnack({ open: true, message, severity: type, autoHideDuration: 3000 });
  };

  const handleClose = () => setSnack({ ...snack, open: false });

  const handleUpload = async (e) => {
  e.preventDefault();

   let tempErrors = { state: '', year: '', referenceLink: '', file: '' };
  let isValid = true;

  const urlRegex = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;

  if (!selectedState) {
    tempErrors.state = 'State is required.';
    isValid = false;
  }

  if (!selectedYear) {
    tempErrors.year = 'Year is required.';
    isValid = false;
  }

  if (referenceLink && !urlRegex.test(referenceLink)) {
    tempErrors.referenceLink = 'Please enter a valid URL';
    isValid = false;
  }

  setErrors(tempErrors);

  if (!isValid) return;


  const formData = new FormData();
  formData.append('State', selectedState);
  formData.append('year', selectedYear);
  formData.append('ReferenceLink', referenceLink);
  if (file) {
    formData.append('file', file);
  }

  try {
    let response;

    if (editItem) {
      const formData = new FormData();
      formData.append('State', selectedState);
      formData.append('year', selectedYear);
      formData.append('ReferenceLink', referenceLink);
      if (file) formData.append('file', file);

       response = await api.HolidayList.editUploadedHolidayList(editItem.id, formData);
    } else {
      const formData = new FormData();
      formData.append('State', selectedState);
      formData.append('year', selectedYear);
      formData.append('ReferenceLink', referenceLink);
      if (file) formData.append('file', file);

      response = await api.HolidayList.uploadHolidayList(formData);
    }

    if (response.status === 200 || response.status === 201) {
      triggerSnackbar('success', response.data?.message || 'Success');
      resetForm();
    } else {
      triggerSnackbar('error', response.data?.message || 'Error occurred');
    }

  }  catch (error) {
        const errMsg =
            error?.response?.data?.message ||
            error?.message ||
            'Something went wrong during the request.';
        triggerSnackbar('error', errMsg);
        }

};


  const resetForm = () => {
    setSelectedState('');
    setSelectedYear('');
    setReferenceLink('');
    setFile(null);
    setEditItem(null);
  };

  const getAllStates = async () => {
    try {
      const response = await api.minimumWages.getMinimumWagesAllStates();
      if (response.status === 200) {
        setStates(response.data.states);
      } else {
        console.error('Error fetching states');
      }
    } catch (error) {
      console.error('Error fetching states', error);
    }
  };

  useEffect(() => {
    getAllStates();
  }, []);

  useEffect(() => {
    if (editItem) {
      setSelectedState(editItem.State || '');
      setSelectedYear(editItem.year || '');
      setReferenceLink(editItem.ReferenceLink === 'N/A' ? '' : editItem.ReferenceLink || '');
    }
  }, [editItem]);
  useEffect(() => {
  if (!editItem) return;

  const hasAnyChange =
    editItem.State !== selectedState ||
    editItem.year !== selectedYear ||
    editItem.ReferenceLink !== referenceLink ||
    file !== null;

  setHasChanged(hasAnyChange);
}, [selectedState, selectedYear, referenceLink, file, editItem]);


  return (
    <>
    <CustomSnackbar
        open={snack.open}
        handleClose={handleClose}
        message={snack.message}
        severity={snack.severity}
    />


    <section className='container mx-auto flex flex-col m-4 space-y-6'>
        <h1 className='text-2xl font-bold text-gray-900  text-center mb-3'>Manage & Upload Holiday List</h1>
        
        <div className='rounded-lg border bg-card text-card-foreground shadow-2xs border-primary/5 '>
        <div className='flex flex-col space-y-1.5 p-6'>
           <h1 className='text-xl font-semibold leading-none tracking-tight text-danger'>Upload Document</h1> 
        </div>

        <div className='p-6'>
            <form className='space-y-6'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                    <div className='space-y-2'>
                        <label className='text-sm font-semibold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'>State</label>
                        <span className='text-red-500'> *</span>
                        <select className='w-full p-2 border border-gray-300 rounded-md'
                            value={selectedState}
                            onChange={(e) => {
                                setSelectedState(e.target.value)
                                if (e.target.value) {
                                    setErrors((prev) => ({ ...prev, state: '' }));
                                }
                            }}
                        >
                            <option value="" disabled>Select State</option>
                            {states.map((state) => (
                                <option key={state.StateId} value={state.State}>{state.State}</option>
                            ))}
                        </select>
                        {error.state && <p className='text-sm text-red-500'>{error.state}</p>}
                    </div>
                    <div className='space-y-2'>
                        <label className='text-sm font-semibold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'>Year</label>
                        <span className='text-red-500'> *</span>
                        <select 
                            className='w-full p-2 border border-gray-300 rounded-md'
                            value={selectedYear}
                            onChange={(e) => {
                                setSelectedYear(e.target.value)
                                if (e.target.value) {
                                    setErrors((prev) => ({ ...prev, year: '' }));
                                }
                            }}
                        >
                            <option value="" disabled>Select Year</option>
                            <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
                            <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                            <option value={new Date().getFullYear() + 1}>{new Date().getFullYear() + 1}</option>
                        </select>
                        {error.year && <p className='text-sm text-red-500'>{error.year}</p>}
                    </div>
                    <div className='space-y-2'>
                        <label className='text-sm font-semibold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'>Reference Link</label>
                        <input type="text" className='w-full p-2 border border-gray-300 rounded-md placeholder:text-gray-400' placeholder='Reference Link' 
                            value={referenceLink}
                            onChange={(e) => {
                                setReferenceLink(e.target.value)
                                const urlRegex = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;
                                if (!e.target.value || urlRegex.test(e.target.value)) {
                                    setErrors((prev) => ({ ...prev, referenceLink: '' }));
                                }
                            }}
                        />
                        {error.referenceLink && <p className='text-sm text-red-500'>{error.referenceLink}</p>}
                    </div>
                        
                    <div className="space-y-2">
                      <label className="text-sm font-semibold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">Upload Document</label>
                      
                      <div
                        className={`w-full p-4 border-2 rounded-md text-center cursor-pointer transition ${
                          isDragActive
                            ? 'border-blue-500 bg-blue-50'
                            : 'border-dashed border-gray-300 hover:bg-gray-50'
                        }`}
                        onClick={() => document.getElementById('fileInput').click()}
                        onDragOver={(e) => {
                          e.preventDefault();
                          setIsDragActive(true);
                        }}
                        onDragLeave={() => setIsDragActive(false)}
                        onDrop={(e) => {
                          e.preventDefault();
                          setIsDragActive(false);
                          const droppedFile = e.dataTransfer.files[0];
                          if (droppedFile) setFile(droppedFile);
                        }}
                      >
                        <p className="text-sm text-gray-600">
                          {file
                            ? `Selected File: ${file.name}`
                            : 'Drag & drop a file here or click to upload'}
                        </p>
                        <input
                          id="fileInput"
                          type="file"
                          accept=".pdf,.doc,.docx,.txt"
                          className="hidden"
                          onChange={(e) => setFile(e.target.files[0])}
                        />
                      </div>

                      {editItem?.FileUrl && editItem.FileUrl !== 'N/A' && (
                        <p className="text-sm text-gray-700 italic">
                          Uploaded File:{' '}
                          <span className="font-medium">
                            {editItem.FileUrl.split('/').pop()}
                          </span>
                        </p>
                      )}
                    </div>

                    

                </div>
                <div className='d-flex p-3 float-end'>
                    {editItem ? (
                        <div className='flex gap-4'>
                           <button
                            type="button"
                            className='w-full btn btn-outline-secondary text-gray-800 p-2 rounded-md hover:bg-gray-500 transition-colors'
                            onClick={resetForm}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`w-full p-2 rounded-md text-white transition-colors ${
                                hasChanged ? 'bg-green-800 hover:bg-green-700' : 'bg-green-600 cursor-not-allowed'
                            }`}
                            onClick={handleUpload}
                            disabled={!hasChanged}
                            >
                            Update
                        </button>

                       
                        </div>
                    ) : (
                        <button
                        type="submit"
                        className={`w-full p-2 rounded-md text-white transition-colors ${
                          selectedState && selectedYear
                            ? 'bg-green-800 text-white'
                            : 'bg-green-700 cursor-not-allowed'
                        }`}
                        onClick={handleUpload}
                        disabled={!selectedState || !selectedYear}
                        >
                        Upload
                        </button>
                    )}
                    </div>

            </form>

        </div>
        </div>



        <HolidayListTable 
        isAdmin={true} 
        onEditHoliday={setEditItem}
        triggerSnackbar={triggerSnackbar}
        />

    </section>
    </>
  )
}

export default UploadHolidayList